import React from 'react';
import { getDataWithQueryString } from '../../../../../api/componentAPIs';
import CommonAccessibleTerminal from '../CommonAccessibleTerminal';
import { withUserProfile } from '../../../../../userProfile/userProfileContext';
import appConstants from '../../../../../appConstants';

class EquipmentMoveTerminals extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      equipmentMoveTerminalData: null,
      isDataLoaded: false,
      showErrorMessage: appConstants.GRID_STATUS.LOADING
    };
  }

  componentDidMount() {
    this._isComponentMounted = true;
    this.loadEquipmentMoveTerminalsData();
  }

  loadEquipmentMoveTerminalsData = () => {
    getDataWithQueryString(
      'GetAllTerminalsToMoveEquipments',
      `terminalCode=${this.props.userData.userProfile.terminal.code}`
    ).then(
      (response) => {
        if (!this._isComponentMounted) {
          return;
        }
        if (response?.status >= 200 && response.status < 400) {
          this.setState({
            equipmentMoveTerminalData: response.data,
            isDataLoaded: true,
            showErrorMessage: appConstants.GRID_STATUS.SUCCESS
          });
          return;
        }
        this.setState({
          equipmentMoveTerminalData: [],
          isDataLoaded: true,
          showErrorMessage: appConstants.GRID_STATUS.ERROR
        });
      },
      (_error) => {
        if (!this._isComponentMounted) {
          return;
        }
        this.setState({
          equipmentMoveTerminalData: [],
          isDataLoaded: true,
          showErrorMessage: appConstants.GRID_STATUS.ERROR
        });
      }
    );
  };

  render() {
    const { equipmentMoveTerminalData, isDataLoaded, showErrorMessage } = this.state;
    return (
      <CommonAccessibleTerminal
        title="Equipment Accessible Terminals"
        description="Move a equipment from current terminal to another accessible terminal."
        accessibleTerminalData={equipmentMoveTerminalData}
        isDataLoaded={isDataLoaded}
        updateAPI="UpdateTerminalsToMoveEquipment"
        getAllAccessibleList={this.loadEquipmentMoveTerminalsData}
        showErrorMessage={showErrorMessage}
      />
    );
  }
}
export default withUserProfile(EquipmentMoveTerminals);
